import { useMutation, useQueryClient } from '@tanstack/react-query';

import { invalidateClinicalBundle } from '../lib/invalidateSessionCaches';
import { sessionsService } from '../services';

import { sessionsKeys } from './useSessions';

export function useSubmitCaseReport(sessionId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (reportId: string) => sessionsService.submitCaseReport(sessionId, reportId),
    onSuccess: () => {
      void qc.invalidateQueries({
        queryKey: sessionsKeys.operation('case-reports', sessionId),
      });
      void qc.invalidateQueries({
        queryKey: sessionsKeys.operation('case-reports-meta', sessionId),
      });
      // Drawer renders from the clinical bundle — refresh so the submitted
      // state (read-only) shows live.
      invalidateClinicalBundle(qc, sessionId);
    },
  });
}
